import { useMemo, useEffect, useRef, useState } from 'react';
import '../Styles/SpaceDomainStyles.css';
import { AvionicsStackGen1, AvionicsStackGen2, SpaceDomain, UhfSpace } from '../Model/SpaceDomainModel';
// import Moon from '../../../../../assets/image/Domains/Space/moon_crack.webp';
// import Earth from '../../../../../assets/image/Domains/Space/earth.webp';
import { useNavigate } from 'react-router-dom';

import Configuration from "../../../../../config/configuration";

const Moon = `${Configuration.S3_URL}Domains/Space/moon_crack.webp`
const Earth = `${Configuration.S3_URL}Domains/Space/earth.webp`
const Mission1 = 'https://www.linkedin.com/posts/iinvsys_poweredbyantaris-antaris-softwareforspace-activity-7286834084188696579-SX2r'
const Mission2 = 'https://www.linkedin.com/posts/iinvsys_janus1-spacemissions-spaceindustry-activity-7031831835814887424-Jgje'


const SpaceDomainView = () => {
    // const stars = useMemo(() => {
    //     const arr = [];
    //     for (let i = 0; i < 500; i++) {
    //         const size = (Math.random() * 2.6 + 0.6).toFixed(1);

    //         arr.push({
    //             id: i,
    //             left: `${Math.random() * 100}%`,
    //             top: `${Math.random() * 100}%`,
    //             size,
    //             scaleMin: (Math.random() * 0.55 + 0.45).toFixed(2),
    //             scaleMax: (Math.random() * 1.6 + 1.05).toFixed(2),
    //             opMin: (Math.random() * 0.35 + 0.05).toFixed(2),
    //             dur: (Math.random() * 3 + 2).toFixed(2) + 's',
    //             delay: (Math.random() * 5).toFixed(2) + 's',
    //             driftDur: (Math.random() * 20 + 10).toFixed(2) + 's',
    //             driftDelay: (Math.random() * 10).toFixed(2) + 's',
    //             driftX: (Math.random() * 14 - 7).toFixed(2) + 'px',
    //             driftY: (Math.random() * 14 - 7).toFixed(2) + 'px',
    //             flare: Math.random() < 0.03,
    //         });
    //     }
    //     return arr;
    // }, []);


    const sectionRef = useRef(null);
    const [inView, setInView] = useState(false);
    const sectionRef2 = useRef(null);
    const [inView2, setInView2] = useState(false);

    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 1024);


    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 1024;
            setIsMobile(mobile);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         ([entry]) => {
    //             if (entry.isIntersecting) {
    //                 setInView(true);
    //                 observer.unobserve(entry.target);
    //             }
    //         },
    //         { threshold: 0.3 }
    //     );

    //     if (sectionRef.current) {
    //         observer.observe(sectionRef.current);
    //     }

    //     return () => {
    //         if (sectionRef.current) observer.unobserve(sectionRef.current);
    //     };
    // }, []);

    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         ([entry]) => {
    //             if (entry.isIntersecting) {
    //                 setInView2(true);
    //                 observer.unobserve(entry.target);
    //             }
    //         },
    //         { threshold: 0.3 }
    //     );

    //     if (sectionRef2.current) {
    //         observer.observe(sectionRef2.current);
    //     }

    //     return () => {
    //         if (sectionRef2.current) observer.unobserve(sectionRef2.current);
    //     };
    // }, []);


    const navigate = useNavigate();
    return (
        <div className="space-domain-view-main-container" >
            {/* <div className="stars">
                {stars.map((s) => (
                    <span
                        key={s.id}
                        className={`star ${s.flare ? 'flare' : ''}`}
                        style={{
                            left: s.left,
                            top: s.top,
                            width: s.size + 'px',
                            height: s.size + 'px',
                            '--scale-min': s.scaleMin,
                            '--scale-max': s.scaleMax,
                            '--op-min': s.opMin,
                            '--dur': s.dur,
                            '--delay': s.delay,
                            '--driftDur': s.driftDur,
                            '--driftDelay': s.driftDelay,
                            '--driftX': s.driftX,
                            '--driftY': s.driftY,
                        }}
                    ></span>
                ))}
            </div> */}
            <div className="space-domain-view-main-landing-screen-container">
                <div className="space-domain-view-main-landing-screen-left-container">
                    <div className='space-domain-view-main-landing-screen-left-container-wrapup'>
                        <span className='space-domain-view-main-landing-screen-left-container-wrapup-heading'>{SpaceDomain.heading}</span>
                        <span className='space-domain-view-main-landing-screen-left-container-wrapup-subheading'>{SpaceDomain.subHeading}</span>

                    </div>
                </div>

                <div className="space-domain-view-main-landing-screen-right-container">
                    <div className='space-domain-view-main-landing-screen-right-container-image'>
                        <img src={Earth} alt='' />
                    </div>
                </div>
            </div>

            <div className='space-domain-view-main-landing-screen-second-image-container'>
                <img src={Moon} alt='' />
            </div>

            <div className='space-domain-view-main-landing-screen-third-image-container'>
                {/* <div className="stars">
                    {stars.map((s) => (
                        <span
                            key={s.id}
                            className={`star ${s.flare ? 'flare' : ''}`}
                            style={{
                                left: s.left,
                                top: s.top,
                                width: s.size + 'px',
                                height: s.size + 'px',
                                '--scale-min': s.scaleMin,
                                '--scale-max': s.scaleMax,
                                '--op-min': s.opMin,
                                '--dur': s.dur,
                                '--delay': s.delay,
                                '--driftDur': s.driftDur,
                                '--driftDelay': s.driftDelay,
                                '--driftX': s.driftX,
                                '--driftY': s.driftY,
                            }}
                        ></span>
                    ))}
                </div> */}
                <div className='space-domain-view-main-landing-screen-third-image-container-heading'>
                    <div className='space-domain-view-main-landing-screen-third-image-container-header-box'></div>
                    <span>{AvionicsStackGen1.product1}</span>
                    <div className='space-domain-view-main-landing-screen-third-image-container-header-box'></div>
                </div>
                {/* <div
                    ref={sectionRef}
                    className='space-domain-view-main-lading-screen-third-image-container-row-arrange'
                >

                    <div className='space-domain-view-main-lading-screen-third-image-container-row-arrange-product-description'>
                        <span>The Avionics Stack Gen 1 is a modular and high-reliability onboard system designed for small satellites, UAVs, and aerospace platforms. It integrates flight control, communication, and data handling into a single, compact unit—optimized for space-grade performance and real-time operation.</span>
                    </div>
                    <div className={`space-domain-view-main-lading-screen-third-image-container-row-arrange-product-1 ${inView ? "animate" : ""}`}>
                        <img src={AvionicsStackGen1Image} alt='' />
                        <div className={`text-circle top ${inView ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>01</div>
                            {AvionicsStackGen1.points[0]}
                        </div>
                        <div className={`text-circle right ${inView ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>02</div>
                            {AvionicsStackGen1.points[1]}</div>
                        <div className={`text-circle bottom ${inView ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>04</div>
                            {AvionicsStackGen1.points[3]}</div>
                        <div className={`text-circle left ${inView ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>03</div>
                            {AvionicsStackGen1.points[2]}</div>
                    </div>

                    <div className={`space-domain-view-main-lading-screen-third-image-container-row-arrange-product-2 ${inView ? "animate" : ""}`}>
                        <img src={RightArrow} alt='' />
                    </div>

                    <div className={`space-domain-view-main-lading-screen-third-image-container-row-arrange-product-3 ${inView ? "animate" : ""}`}>
                        <img src={AvionicsStackGen1Component} alt='' />
                    </div>
                </div> */}

                {isMobile ?
                    <div className='space-domain-view-landing-screen-third-image-product-image-mobile'>
                        <img src={AvionicsStackGen1.mobileimage} alt='' />
                    </div> :
                    <div className='space-domain-view-landing-screen-third-image-product-image'>
                        <img src={AvionicsStackGen1.image} alt='' />
                    </div>

                }

                <div className='space-domain-view-landing-screen-third-image-navigation-helper'>
                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation'>
                        <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1'>
                            <span className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1-heading'>Space Heritage</span>
                            <a className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1-navigation' 
                            href={Mission1} target="_blank" rel="noopener noreferrer">Mission 1 →</a>
                            <a className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1-navigation'
                            href={Mission2} target="_blank" rel="noopener noreferrer">Mission 2 →</a>
                        </div>
                        <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2'>
                            {AvionicsStackGen1.navigation.map((value, index) => (
                                <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1' key={index}>
                                    <span>{value?.description}</span>
                                    <span>:</span>
                                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1-image'>
                                        <a href={value.link} target="_blank" rel="noopener noreferrer">
                                            <img src={value?.image} alt='' />
                                        </a>
                                    </div>
                                </div>
                            ))

                            }
                        </div>
                    </div>
                </div>

                <div className='space-domain-view-landing-screen-third-image-navigation-helper-mobile'>

                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1'>
                        <span className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1-heading'>Space Heritage</span>
                        <a className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1-navigation'
                        href={Mission1} target="_blank" rel="noopener noreferrer">Mission 1 →</a>
                        <a className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section1-navigation'
                        href={Mission2} target="_blank" rel="noopener noreferrer">Mission 2 →</a>
                    </div>

                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2'>
                        {AvionicsStackGen1.navigation.map((value, index) => (
                            <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1' key={index}>
                                <span>{value?.description}</span>
                                <span>:</span>
                                <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1-image'>
                                    <a href={value.link} target="_blank" rel="noopener noreferrer">
                                        <img src={value?.image} alt='' />
                                    </a>
                                </div>
                            </div>
                        ))

                        }
                    </div>

                </div>

            </div>

            <div className='space-domain-view-main-landing-screen-third-image-container'>
                {/* <div className="stars">
                    {stars.map((s) => (
                        <span
                            key={s.id}
                            className={`star ${s.flare ? 'flare' : ''}`}
                            style={{
                                left: s.left,
                                top: s.top,
                                width: s.size + 'px',
                                height: s.size + 'px',
                                '--scale-min': s.scaleMin,
                                '--scale-max': s.scaleMax,
                                '--op-min': s.opMin,
                                '--dur': s.dur,
                                '--delay': s.delay,
                                '--driftDur': s.driftDur,
                                '--driftDelay': s.driftDelay,
                                '--driftX': s.driftX,
                                '--driftY': s.driftY,
                            }}
                        ></span>
                    ))}
                </div> */}

                <div className='space-domain-view-main-landing-screen-third-image-container-heading'>
                    <div className='space-domain-view-main-landing-screen-third-image-container-header-box'></div>
                    <span>{AvionicsStackGen2.product1}</span>
                    <div className='space-domain-view-main-landing-screen-third-image-container-header-box'></div>
                </div>


                {/* <div className='space-domain-view-landing-screen-third-image-product-image'>
                    <img src={AvionicsStackGen2.image} alt='' />
                </div> */}

                {isMobile ?
                    <div className='space-domain-view-landing-screen-third-image-product-image-mobile'>
                        <img src={AvionicsStackGen2.mobileimage} alt='' />
                    </div> :
                    <div className='space-domain-view-landing-screen-third-image-product-image'>
                        <img src={AvionicsStackGen2.image} alt='' />
                    </div>

                }

                <div className='space-domain-view-landing-screen-third-image-navigation-helper-right'>
                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation'>

                        <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-alt'>
                            {AvionicsStackGen2.navigation.map((value, index) => (
                                <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1' key={index}>
                                    <span>{value?.description}</span>
                                    <span>:</span>
                                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1-image'>
                                        <a href={value.link} target="_blank" rel="noopener noreferrer">
                                            <img src={value?.image} alt='' />
                                        </a>
                                    </div>
                                </div>
                            ))

                            }
                        </div>
                    </div>
                </div>

                <div className='space-domain-view-landing-screen-third-image-navigation-helper-mobile'>



                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2'>
                        {AvionicsStackGen2.navigation.map((value, index) => (
                            <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1' key={index}>
                                <span>{value?.description}</span>
                                <span>:</span>
                                <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1-image'>
                                    <a href={value.link} target="_blank" rel="noopener noreferrer">
                                        <img src={value?.image} alt='' />
                                    </a>
                                </div>
                            </div>
                        ))

                        }
                    </div>

                </div>


            </div>

            <div className='space-domain-view-main-landing-screen-uhf-for-space-project'>

                <div className='space-domain-view-main-landing-screen-uhf-for-space-project-wrapup'>

                    {isMobile && <div className='space-domain-view-main-landing-screen-third-image-container-heading'>
                        <div className='space-domain-view-main-landing-screen-third-image-container-header-box'></div>
                        <span>{UhfSpace.product1}</span>
                        <div className='space-domain-view-main-landing-screen-third-image-container-header-box'></div>
                    </div>
                    }

                    {isMobile ?
                        <div className='space-domain-view-landing-screen-third-image-product-image-mobile'>
                            <img src={UhfSpace.mobileimage} alt='' />
                        </div> :
                        <div style={{ width: "100%" }}>
                            <img src={UhfSpace.image} alt='' style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                        </div>

                    }

                    <div className='space-domain-view-landing-screen-third-image-navigation-helper'>
                        <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation'>

                            <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-alt'>
                                {UhfSpace.navigation.map((value, index) => (
                                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1' key={index}>
                                        <span>{value?.description}</span>
                                        <span>:</span>
                                        <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1-image'>
                                            <a href={value.link} target="_blank" rel="noopener noreferrer">
                                                <img src={value?.image} alt='' />
                                            </a>
                                        </div>
                                    </div>
                                ))

                                }

                            </div>
                        </div>
                    </div>

                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-mobile'>
                        <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2'>
                            {UhfSpace.navigation.map((value, index) => (
                                <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1' key={index} style={{paddingBottom:"2vh"}}>
                                    <span>{value?.description}</span>
                                    <span>:</span>
                                    <div className='space-domain-view-landing-screen-third-image-navigation-helper-navigation-section2-part1-image'>
                                        <a href={value.link} target="_blank" rel="noopener noreferrer">
                                            <img src={value?.image} alt='' />
                                        </a>
                                    </div>
                                </div>
                            ))

                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default SpaceDomainView;





{/* <div
                    ref={sectionRef2}
                    className='space-domain-view-main-lading-screen-fourth-image-container-row-arrange'
                >

                    <div className={`space-domain-view-main-lading-screen-fourth-image-container-row-arrange-product-3 ${inView2 ? "animate" : ""}`}>
                        <img src={AvionicsStackGen2Component} alt='' />
                    </div>



                    <div className={`space-domain-view-main-lading-screen-fourth-image-container-row-arrange-product-2 ${inView2 ? "animate" : ""}`}>
                        <img src={LeftArrow} alt='' />
                    </div>


                    <div className={`space-domain-view-main-lading-screen-fourth-image-container-row-arrange-product-1 ${inView2 ? "animate" : ""}`}>
                        <img src={AvionicsStackGen2Image} alt='' />
                        <div className={`text-circle-fourth top ${inView2 ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>01</div>
                            {AvionicsStackGen2.points[0]}
                        </div>
                        <div className={`text-circle-fourth right ${inView2 ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>02</div>
                            {AvionicsStackGen2.points[1]}</div>
                        <div className={`text-circle-fourth bottom ${inView2 ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>04</div>
                            {AvionicsStackGen2.points[3]}</div>
                        <div className={`text-circle-fourth left ${inView2 ? "animate" : ""}`}>
                            <div className='space-domain-view-main-landing-screen-text-number-circle'>03</div>
                            {AvionicsStackGen2.points[2]}</div>
                    </div>


                    <div className='space-domain-view-main-lading-screen-fourth-image-container-row-arrange-description'>
                        The Avionics Stack Gen 2 represents the next evolution in onboard computing for aerospace and satellite platforms. Building upon the proven reliability of Gen 1, it delivers enhanced processing power, modular scalability, and AI-driven autonomy—enabling advanced mission control, communication, and data analytics in a unified system.
                    </div>

                </div> */}